/* Tiny i18n: English strings are the keys; missing translations fall back to English. Language stored in localStorage and on the user's account. */
import { createContext, Fragment, useContext, useState } from "react";
import axios from "axios";
import { gu } from "./gu";
import { hi } from "./hi";
import { es } from "./es";

export const LANGS = [{ code: "en", label: "English", short: "EN" }, { code: "gu", label: "ગુજરાતી", short: "ગુ" }, { code: "hi", label: "हिन्दी", short: "हि" }, { code: "es", label: "Español", short: "ES" }];
const DICT = { en: {}, gu, hi, es };
const SPEECH = { en: "en-US", gu: "gu-IN", hi: "hi-IN", es: "es-US" };
let current = localStorage.getItem("tp_lang") || "en";
if (!DICT[current]) current = "en";

export const t = (s, vars) => {
  if (typeof s !== "string") return s;
  let out = DICT[current]?.[s] || DICT[current]?.[s.trim()] || s;
  if (vars) for (const [k, v] of Object.entries(vars)) out = out.replace(new RegExp(`\\{${k}\\}`, "g"), v);
  return out;
};
export const getLang = () => current;
export const langLabel = () => LANGS.find((l) => l.code === current)?.label || "English";

/* Read text aloud in the current language (Web Speech API; silently does nothing when unsupported). */
export const speak = (text) => {
  try {
    if (!("speechSynthesis" in window) || !text) return false;
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = SPEECH[current] || "en-US";
    u.rate = 0.92;
    const v = window.speechSynthesis.getVoices().find((x) => x.lang?.toLowerCase().startsWith((SPEECH[current] || "en").slice(0, 2)));
    if (v) u.voice = v;
    window.speechSynthesis.speak(u);
    return true;
  } catch { return false; }
};
export const dateLocale = () => ({ en: "en-US", gu: "gu-IN", hi: "hi-IN", es: "es-US" }[current] || "en-US");
export const canSpeak = () => typeof window !== "undefined" && "speechSynthesis" in window;

const persist = (code) => {
  const token = localStorage.getItem("token");
  if (token) axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/auth/prefs`, { lang: code }, { headers: { Authorization: `Bearer ${token}` } }).catch(() => {});
};

const LangCtx = createContext({ lang: "en", setLang: () => {} });
export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(current);
  const apply = (code) => { current = DICT[code] ? code : "en"; localStorage.setItem("tp_lang", current); setLangState(current); document.documentElement.lang = current; };
  const setLang = (code, { save = true } = {}) => { apply(code); if (save) { persist(current); window.dispatchEvent(new Event("tp-lang-change")); } };
  return <LangCtx.Provider value={{ lang, setLang }}><Fragment key={lang}>{children}</Fragment></LangCtx.Provider>;
};
export const useLang = () => useContext(LangCtx);
